import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Chip,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";

const SupportView = () => {
  const navigate = useNavigate();

  // Mock ticket data (replace with API data as needed)
  const [ticket, setTicket] = useState({
    id: "QR-2001",
    type: "Query" as "Chat" | "Query" | "Complaint",
    subject: "Account verification",
    category: "Account",
    status: "Open" as "Open" | "Under Review" | "Resolved",
    user: { name: "Alex Lee", email: "alex@example.com" },
    createdAt: "01-Sep-2025 10:10 AM",
    messages: [
      {
        id: 1,
        authorType: "User" as "User" | "Admin",
        authorName: "Alex Lee",
        text: "I can't verify my account.",
        time: "01-Sep-2025 10:10 AM",
      },
      {
        id: 2,
        authorType: "Admin" as "User" | "Admin",
        authorName: "Support Agent",
        text: "We're looking into this for you.",
        time: "01-Sep-2025 10:15 AM",
      },
    ],
  });

  const [reply, setReply] = useState("");
  const handleStatusChange = (e: SelectChangeEvent) => {
    const value = e.target.value as "Open" | "Under Review" | "Resolved";
    setTicket((prev) => ({ ...prev, status: value }));
  };

  const sendReply = () => {
    const text = reply.trim();
    if (!text) return;
    setTicket((prev) => ({
      ...prev,
      messages: [
        ...prev.messages,
        {
          id: prev.messages.length + 1,
          authorType: "Admin",
          authorName: "Support Agent",
          text,
          time: new Date().toLocaleString(),
        },
      ],
    }));
    setReply("");
  };

  const statusColor = (status: string) => {
    if (status === "Resolved") return "success";
    if (status === "Under Review") return "warning";
    return "default";
  };

  return (
    <>
      <div className="main_title">
        <h1>Support Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/customer-supports")}> Manage Customer Support </button> -
          Support Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="table_header">
          <div className="left_s">
            <h2>{ticket.type} Detail</h2>
          </div>
          <div className="right_s">
            <Chip size="small" label={ticket.status} color={statusColor(ticket.status) as any} />
          </div>
        </div>

        <div className="gap_p">
          <div className="w_33">
            <h6>Ticket ID</h6>
            <p>{ticket.id}</p>
          </div>
          <div className="w_33">
            <h6>Subject</h6>
            <p>{ticket.subject}</p>
          </div>
          {ticket.type !== "Chat" && (
            <div className="w_33">
              <h6>Category</h6>
              <p>{ticket.category}</p>
            </div>
          )}
          <div className="w_33">
            <h6>User</h6>
            <p>
              <b>{ticket.user.name}</b>
              <br />
              <span>{ticket.user.email}</span>
            </p>
          </div>
          <div className="w_33">
            <h6>Created</h6>
            <p>{ticket.createdAt}</p>
          </div>
          <div className="w_33">
            <h6>Update Status</h6>
            <Select fullWidth value={ticket.status} onChange={handleStatusChange}>
              <MenuItem value="Open">Open</MenuItem>
              <MenuItem value="Under Review">Under Review</MenuItem>
              <MenuItem value="Resolved">Resolved</MenuItem>
            </Select>
          </div>
        </div>
      </div>

      <div className="cards mt_20">
        <div className="table_header">
          <div className="left_s">
            <h2>Conversation</h2>
          </div>
        </div>

        <div className="conversation_list" style={{ padding: 16 }}>
          {ticket.messages.map((m) => (
            <div key={m.id} className={`conversation_item ${m.authorType === "Admin" ? "is_admin" : ""}`} style={{ marginBottom: 12 }}>
              <div className="user_block">
                <figure>
                  <img src="/static/images/user_placeholder.png" alt="User" />
                </figure>
                <p>
                  <b>{m.authorName}</b>
                  <span>{m.time}</span>
                </p>
              </div>
              <div style={{ marginTop: 6 }}>
                <p>{m.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="reply_box" style={{ padding: 16, borderTop: "1px solid #eee" }}>
          <Box sx={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
            <TextField
              fullWidth
              multiline
              minRows={2}
              placeholder="Type your reply..."
              value={reply}
              onChange={(e) => setReply(e.target.value)}
            />
            <Button className="btn btn_primary" onClick={sendReply}>Send</Button>
          </Box>
        </div>
      </div>
    </>
  );
};

export default SupportView;
